/**
 * @ngdoc object
 * @name bo.objects.controller:BoObjectCreateController
 *
 * @description
 *
 */
import {AbstractEditorController} from './abstract-editor-controller';

class BoObjectCreateController extends AbstractEditorController {

    constructor($http, $state, $stateParams, Alert, growl, NavHelper) {
        super($http, $state, $stateParams, Alert, growl, NavHelper);
        this.headline = 'Create new Bookable-object';
        this.model = {
            label: '',
            type: 'option_set',
            meta: {}
        };

        this.typeSelectionDisabled = false;

        this._loadAvailableTypes().then(() => {
            this._updateCurrentActiveType();
        });
    }

    save() {
        this.api.post(`bo/objects`, this._prepareModelForApi()).then((response) => {
            this.growl.success('Object was saved successful', {title: 'Success'});
            const newObject = response.data.data;
            this.state.go('app.bo.objects.details', {
                objectId: newObject.id
            });
        }, () => {
            this.growl.error('Please try again', {title: 'Save error'});
        });
    }

    cancel() {
        this.state.go('app.bo.objects.index', {
            id: this.model.id
        })
    }
}

angular
    .module('festzelt-os.modules.bo.objects')
    .controller('BoObjectCreateController', BoObjectCreateController);



// WEBPACK FOOTER //
// ./src/app/modules/bo/objects/controllers/create-controller.js